import { useState } from 'react';
import { t } from 'i18next';

import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import ScrollPagination from '../../components/Paginations/ScrollPagination';
import QuoteCard from './components/QuoteCard/QuoteCard';

const QuoteList = ({ shipmentList, onSelect, selectedShipments, handleCopy, isLoading, handleNextPage, hasMore }) => {
  const [copyModalOpen, setCopyModalOpen] = useState(false);

  const handleModalActions = (value) => {
    handleCopy(copyModalOpen, value);
    setCopyModalOpen(false);
  };

  return (
    <>
      <ScrollPagination
        className={`${shipmentList.length > 0 ? 'mb-15' : 'pb-15'} h-100`}
        loadMore={handleNextPage}
        isLoading={isLoading}
        hasMore={hasMore}
        scrollOffset={30}
        isSkipScrollToBottom
      >
        {shipmentList.map((row) => (
          <QuoteCard
            key={row.quoteKey}
            data={row}
            onSelect={onSelect}
            isSelected={selectedShipments.includes(row.quoteKey)}
          />
        ))}
      </ScrollPagination>
      <ConfirmationModal
        onOk={() => handleModalActions(1)}
        onCancel={() => handleModalActions(0)}
        onClose={() => setCopyModalOpen(false)}
        open={Boolean(copyModalOpen)}
        description={t('translation:shipment.card.description')}
        title={t('translation:shipment.card.title')}
      />
    </>
  );
};

export default QuoteList;
